import { TYPE_SIZES, TYPE_PLATFORM } from '../../utils/globalConst.js';
import vClickOutside from 'v-click-outside';
import ElementItem from '../ElementItem/ElementItem.vue.js';
import ArrowIcon from '../../assets/icons/24/Arrow_down_24.vue.js';

//
var script = {
  name: 'SelectControl',
  components: {
    ElementItem: ElementItem,
    ArrowIcon: ArrowIcon
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  inject: {
    formItem: {
      default: ''
    }
  },

  provide: function provide() {
    return {
      selectControl: this
    };
  },

  model: {
    prop: 'value',
    event: 'selected'
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      default: function () { return []; },
      // [{ value: 'itemValue', label: 'itemLabel' }]
      required: true
    },
    size: {
      type: String,
      default: TYPE_SIZES.normal.value
    },
    sizeOption: {
      type: String,
      default: TYPE_SIZES.normal.value
    },
    platform: {
      type: String,
      default: TYPE_PLATFORM.mobile.value
    },
    placeholder: {
      type: String,
      default: 'Выберите вариант'
    },
    valuePath: {
      type: String,
      default: 'value'
    },
    labelPath: {
      type: String,
      default: 'label'
    },
    showAppendTrigger: {
      type: Boolean,
      default: true
    },
    maxHeightOptionsList: {
      type: Number,
      default: 200
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    tagNameOptionsList: {
      type: String,
      default: 'ul'
    },
    id: {
      type: String,
      default: ''
    },
    isOpeningSuggestionsUp: {
      type: Boolean,
      default: true
    }
  },
  data: function () { return ({
    isOpen: false
  }); },
  computed: {
    currentOption: function currentOption() {
      var this$1 = this;

      return this.items.find(function (item) { return item[this$1.valuePath] === this$1.value; });
    },

    currentLabel: function currentLabel() {
      return this.currentOption ? this.currentOption[this.labelPath] : this.placeholder;
    },

    classList: function classList() {
      var obj;

      return ( obj = {}, obj[TYPE_SIZES.small.className] = this.size === TYPE_SIZES.small.value, obj[TYPE_SIZES.large.className] = this.size === TYPE_SIZES.large.value, obj['_slot-button'] = !!this.$slots['trigger-button'], obj );
    },

    nativeId: function nativeId() {
      return this.formItem ? this.formItem.nativeId : this.id;
    }

  },
  watch: {
    isOpen: function isOpen(value) {
      if (value) {
        this.$nextTick(this.defineSizes);
      }
    }

  },

  mounted: function mounted() {
    if (this.isOpen) {
      this.$nextTick(this.defineSizes);
    }
  },

  methods: {
    handlerClickItem: function handlerClickItem(event, item) {
      this.$emit('selected', item[this.valuePath]);
      this.isOpen = false;
    },

    handlerHideSelect: function handlerHideSelect() {
      this.$emit('hide-select');
    },

    handlerClickButton: function handlerClickButton(event) {
      this.isOpen = !this.isOpen;
      this.$emit('click', event);
    },

    handlerClickOutside: function handlerClickOutside(event) {
      this.$emit('click-outside', event);
      this.onHideOptions();
    },

    onHideOptions: function onHideOptions() {
      this.isOpen = false;
    },

    onOpenOptions: function onOpenOptions() {
      this.isOpen = true;
    },

    defineSizes: function defineSizes() {
      var this$1 = this;

      if (this.$refs.button && this.$refs.result) {
        var resultEl = this.$refs.result;
        var buttonEl = this.$refs.button;
        var rectsButton = buttonEl.getBoundingClientRect();
        var bottom = window.innerHeight - rectsButton.top - rectsButton.height;

        var position = function (topPosition, direction) {
          if ( direction === void 0 ) direction = 'bottom';

          resultEl.style.top = topPosition + "px";
          resultEl.style.boxShadow = "0 " + (direction !== 'bottom' ? '-' : '') + "2px 4px rgba(0, 0, 0, 0.16)";
          this$1.$emit('opened-select', direction);
        };

        if (bottom < resultEl.clientHeight && this.isOpeningSuggestionsUp) {
          position(-resultEl.clientHeight, 'top');
        } else {
          position(rectsButton.height);
        }
      }
    }

  }
};

export default script;
